/**
 * Generique
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package fr.arcplex.network.impl.legacy

import fr.arcplex.network.AuthProvider
import fr.arcplex.network.cache.*
import fr.arcplex.network.http.*
import io.ktor.http.*

class DefaultApi(basePath: String = "/", val auth: AuthProvider, allowInvalidCertificates: Boolean = false) :
    ApiClient(basePath, allowInvalidCertificates) {

    fun replacePlaceholders(inString: String) : String {
        return inString.replace(
            "#USER_TOKEN#",
            auth.getUserToken() ?: ""
        ).replace(
            "#MAC_ADDRESS#",
            auth.getMacAddress()
        )
    }

    suspend fun getGeneriqueGetAddFilmFavoris(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/addFilmFavoris".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetCallbackBouygues(prettyUrl: String, theOrigin: String, prefix: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/bouyguesbha/callbackExternalContractId".replace("{prefix}", prefix), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetCheckCodeParentalGenerique(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/check_code_parental_generique".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetCheckCodeParentalGeneriqueErreur(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/check_code_parental_generique_erreur".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetCheckCodeParentalGeneriqueOk(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/check_code_parental_generique_ok".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetDeleteFilmFavoris(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/deleteFilmFavoris".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetDemandeDesabonnementGenerique(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/demande_desabonnement_generique".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetDemandeDesynchro(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/demande_desynchro".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetGetLicence(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/getLicence".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetInfosViewVideoWebV2(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/getInfosViewVideoWebV2".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetLineContent(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null, jsonArrLines: String? = null): JsonMap? {
        val localVariableQuery: MultiValueMap = mutableMapOf<String, List<String>>().apply {
            if (jsonArrLines != null) {
                put("jsonArrLines", listOf(jsonArrLines))
            }
        }
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/getLineContent".replace("{prefix}", prefix).replace("{version}", version), 
            query = localVariableQuery + (if (userToken != null) mapOf("user_token" to listOf(userToken)) else  mapOf()),
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetLogErreurAppelWs(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/logErreurAppelWS".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetPage(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null, id_page: String? = null, id_film: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }

        val pathComplement: MutableMap<String, List<String>> = mutableMapOf()
        if(id_page != null) pathComplement["idpage"]=listOf(id_page)
        if(id_film != null) pathComplement["idfilm"]=listOf(id_film)
        if(userToken != null) pathComplement["user_token"]=listOf(userToken)

        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/getPage".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders,
            query = pathComplement
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetRecherche(prefix: String, version: String): JsonMap? {
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/getRecherche".replace("{prefix}", prefix).replace("{version}", version)
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetRootPage(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/getRootPage".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetToken(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/getToken".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetVideoStarted(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/video_started".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetVideoStopped(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/video_stopped".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGeneriqueGetViewVideo(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null): JsonMap? {
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            "/api/generique{prefix}/V{version}/viewVideo".replace("{prefix}", prefix).replace("{version}", version), 
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun postGeneriqueGetLineContentMultiples(prettyUrl: String, theOrigin: String, prefix: String, version: String, userToken: String? = null, jsonArrLines: String? = null): JsonMap? {
        val localVariableQuery: MultiValueMap = mutableMapOf<String, List<String>>().apply {
            if (jsonArrLines != null) {
                put("jsonArrLines", listOf(jsonArrLines))
            }
        }
        val localVariableHeaders: MutableMap<String, String> = mutableMapOf()
        localVariableHeaders["pretty-url"] = prettyUrl
        localVariableHeaders["The-Origin"] = theOrigin
        userToken?.let { localVariableHeaders["user-token"] = it }
        
        val localVariableConfig = RequestConfig(
            RequestMethod.POST,
            "/api/generique{prefix}/V{version}/getLineContentMultiples".replace("{prefix}", prefix).replace("{version}", version), 
            query = localVariableQuery,
            headers = localVariableHeaders
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun postGeneriquePostChangeParentalControl(prefix: String, version: String): JsonMap? {
        val localVariableConfig = RequestConfig(
            RequestMethod.POST,
            "/api/generique{prefix}/V{version}/changeParentalControl".replace("{prefix}", prefix).replace("{version}", version)
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun postGeneriquePostCheckAdultPassword(prefix: String, version: String): JsonMap? {
        val localVariableConfig = RequestConfig(
            RequestMethod.POST,
            "/api/generique{prefix}/V{version}/FG_checkAdultPassword".replace("{prefix}", prefix).replace("{version}", version)
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    suspend fun getGenericCallURL(pretty: String, url: String, userToken: String? = null, fullURL: String? = null): JsonMap? {
        val replacedUrl = replacePlaceholders(url)
        val uri = Url(replacedUrl)
        
        val localVariableConfig = RequestConfig(
            RequestMethod.GET,
            uri.encodedPath,
            headers = mapOf("pretty_url" to pretty),
            query = (uri.parameters.entries().associate { it.key to it.value }) + (if (userToken != null) mapOf("user_token" to listOf(userToken)) else  mapOf())
        )
        val response = requestJson(localVariableConfig)

        return when (response.responseType) {
            ResponseType.Success -> (response as Success).data
            ResponseType.Informational -> TODO()
            ResponseType.Redirection -> TODO()
            ResponseType.ClientError -> throw ClientException((response as ClientError<*>).body as? String ?: "Client error")
            ResponseType.ServerError -> throw ServerException((response as ServerError<*>).message ?: "Server error")
        }
    }

    fun parseQuery(path: String?): Map<String?, String?>? {
        if (path == null || path.isEmpty()) return null
        val indexOfQ = path.indexOf("?")
        if (indexOfQ == -1) return null

        val queryString = path.substring(indexOfQ + 1)
        val queryStringArray = queryString.split("&".toRegex()).dropLastWhile { it.isEmpty() }.toTypedArray()
        val kvMap: MutableMap<String?, String?> = HashMap<String?, String?>()
        for (kvString in queryStringArray) {
            val indexOfE = kvString.indexOf("=")
            if (indexOfE == -1 || indexOfE == 0) return null
            val kvPairArray = kvString.split("=".toRegex()).dropLastWhile { it.isEmpty() }.toTypedArray()
            kvMap.put(kvPairArray[0], kvPairArray[1])
        }

        return kvMap
    }

    internal interface ParseQueryParams {
        fun exec(queryString: String): Map<String, List<String>>
    }

    internal class ParseQueryParamsImpl : ParseQueryParams {
        override fun exec(queryString: String): Map<String, List<String>> {
            return queryString
                .split("&")
                .mapNotNull { keyAndValue ->
                    val keyAndValueList = keyAndValue.split("=")
                    keyAndValueList.takeIf { it.size == 2 }
                }
                .mapNotNull { keyAndValueList ->
                    val (key, value) = keyAndValueList
                    (key to value.trim()).takeIf { value.isNotBlank() }
                }
                .groupBy { (key, _) -> key }
                .map { mapEntry ->
                    mapEntry.key to mapEntry.value.map { it.second }
                }
                .toMap()
        }
    }
}
